import { render, staticRenderFns } from "./Universities.vue?vue&type=template&id=75c1267c&"
import script from "./Universities.vue?vue&type=script&lang=js&"
export * from "./Universities.vue?vue&type=script&lang=js&"
import style0 from "./Universities.vue?vue&type=style&index=0&id=75c1267c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports